<template>
  <v-ons-toolbar>
    <div class="left">
      <v-ons-back-button>{{ $t("ui.back") }}</v-ons-back-button>
    </div>
    <div class="center" style="overflow-x: auto;"><div style="overflow-x: unset;">{{ title }}</div></div>
    <div class="right back-to-home js-backToHome" v-if="enableHome" @click="navigatorResetMain()">{{ $t("ui.home") }}</div>
  </v-ons-toolbar>
</template>

<script>
export default {
  props: ['title', 'loading', 'enableHome', 'enableTicker'],
  computed: {
    pageStack() {
      return this.$store.state.navigator.stack;
    },
  },

  mounted() {
    if (this.enableTicker) {
      let tickerEl = this.$el.querySelector('.center > div');
      setTimeout(() => {
        if (tickerEl.clientWidth < tickerEl.scrollWidth) {
          tickerEl.classList.add('title-ticker-animate');
        }
      }, 2000);
    }
  },
};
</script>
